import { Pipe, PipeTransform } from '@angular/core';

@Pipe( {
  name: 'icons'
} )
export class FeatureIconPipe implements PipeTransform {
  transform ( items: any[], activeItems?: any[] ) {
    let array = [];

    for ( let i = 0; i < items.length; i++ ) {
      let obj = items[i];
      for ( let j = 0; j < activeItems.length; j++ ) {
        if ( i == activeItems[j] ) {
          array.push( obj );
        }
      }
    }
    return array;
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/pipe/feature-icon.pipe.ts